import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatRadioModule } from '@angular/material/radio'
import { MatChipsModule } from '@angular/material/chips'
import { MatTooltipModule } from '@angular/material/tooltip'
import moment from 'moment/moment'
import { EscalaFrotaService } from '../../../core/services/schedule/escala-frota/escala-frota.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { CODIGO_EXCLUSAO_LABEL, identificacaoCandidato } from '../../../core/models/escala-frota.model'
import { convertCurrency } from '../../../shared/utils/utils'

@Component({
  selector: 'pre-escala-frota',
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatChipsModule,
    MatTooltipModule,
  ],
  templateUrl: './pre-escala-frota.component.html',
  styleUrl: './pre-escala-frota.component.scss',
  standalone: true,
})
export class PreEscalaFrotaComponent implements OnInit {
  constructor(
    private escalaFrotaService: EscalaFrotaService,
    private snackbar: SnackbarCustomService,
  ) {}

  codigoExclusaoLabel = CODIGO_EXCLUSAO_LABEL
  identificacaoCandidato = identificacaoCandidato

  data: Date | null = null
  estado = ''
  loading = false
  buscou = false
  sugestoes: any[] = []
  confirmando = false

  loadingResumo = false
  resumoValor: any[] = []

  ngOnInit(): void {
    const amanha = new Date()
    amanha.setDate(amanha.getDate() + 1)
    this.data = amanha
    this.carregarResumoValor()
  }

  get totalSelecionados(): number {
    return this.sugestoes.filter((s) => !!s.selecionadoMotoristaId).length
  }

  sugerirDia(): void {
    if (!this.data) {
      this.snackbar.error('Selecione uma data.')
      return
    }
    this.loading = true
    this.buscou = true
    const dataStr = moment(this.data).format('DD/MM/YYYY')
    this.escalaFrotaService.sugerirDia(dataStr, this.estado || null).subscribe({
      next: (res: any) => {
        this.sugestoes = (res.data ?? []).map((s: any) => ({
          ...s,
          selecionadoMotoristaId: s.motoristaSugeridoId,
          expandido: false,
        }))
        this.loading = false
        if (this.sugestoes.length === 0) {
          this.snackbar.info(res.message ?? 'Nenhum serviço sem motorista nessa data.')
        }
      },
      error: (err: any) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
    })
  }

  toggleExpandir(sugestao: any): void {
    sugestao.expandido = !sugestao.expandido
  }

  confirmarEscala(): void {
    const alocacoes = this.sugestoes
      .filter((s) => s.selecionadoMotoristaId)
      .map((s) => ({ ordemServicoId: s.ordemServicoId, motoristaId: s.selecionadoMotoristaId }))
    if (alocacoes.length === 0) {
      this.snackbar.error('Selecione ao menos um motorista pra confirmar.')
      return
    }
    this.confirmando = true
    this.escalaFrotaService.confirmar({ alocacoes }).subscribe({
      next: (res: any) => {
        this.snackbar.success(res.message ?? `${res.data} serviço(s) escalado(s).`)
        this.confirmando = false
        this.sugerirDia()
        this.carregarResumoValor()
      },
      error: (err: any) => {
        this.confirmando = false
        this.snackbar.errorRequest(err)
      },
    })
  }

  formatCurrency(value: any): string {
    return value != null ? `R$ ${convertCurrency(value)}` : '-'
  }

  carregarResumoValor(): void {
    this.loadingResumo = true
    this.escalaFrotaService.resumoValorMotorista({}).subscribe({
      next: (res: any) => {
        this.resumoValor = res.data ?? []
        this.loadingResumo = false
      },
      error: () => {
        this.loadingResumo = false
      },
    })
  }
}
